/* jaco-facet-filters.js (v2 — grouped/stackable) — client-side tag filter.
   OR within a group, AND across groups (standard faceted filtering).
   Shows/hides .jaco-ff-item[data-ff-tags] based on ?ff=tag1,tag2 (handleized values). */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__jacoFFInit) return;
    root.__jacoFFInit = true;

    var collectionUrl = root.getAttribute('data-collection-url') || window.location.pathname;
    function onTagSubPath() {
      var base = collectionUrl.replace(/\/+$/, '');
      var here = window.location.pathname.replace(/\/+$/, '');
      return here !== base && here.indexOf(base + '/') === 0;
    }

    var grid = document.querySelector('[data-ff-grid]') || document.querySelector('#collection-grid');
    var items = grid ? Array.prototype.slice.call(grid.querySelectorAll('.jaco-ff-item')) : [];
    var resultCount = document.querySelector('[data-ff-result-count]');
    var emptyEl = grid ? grid.querySelector('[data-ff-empty]') : null;
    var activeWrap = root.querySelector('[data-ff-active]');
    var badge = root.querySelector('[data-ff-count]');

    items.forEach(function (it) {
      it.__tags = (it.getAttribute('data-ff-tags') || '').split(/\s+/).filter(Boolean);
    });

    // value -> { label, group } map (from pills)
    var valueMeta = {};
    root.querySelectorAll('.jaco-ff__pill[data-ff-value]').forEach(function (p) {
      valueMeta[p.getAttribute('data-ff-value')] = {
        label: p.getAttribute('data-ff-label') || p.textContent.trim(),
        group: p.getAttribute('data-ff-group') || 'group'
      };
    });
    // fallback from checkboxes (in case a value only exists in drawer)
    root.querySelectorAll('.jaco-ff__check input[data-ff-value]').forEach(function (cb) {
      var v = cb.getAttribute('data-ff-value');
      if (!valueMeta[v]) valueMeta[v] = { label: cb.parentNode.textContent.trim(), group: cb.getAttribute('data-ff-group') || 'group' };
    });

    function getSelected() {
      var params = new URLSearchParams(window.location.search);
      var ff = params.get('ff');
      if (!ff) return [];
      return ff.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }

    function writeUrl(values) {
      var params = new URLSearchParams(window.location.search);
      if (values.length) params.set('ff', values.join(','));
      else params.delete('ff');
      var qs = params.toString();
      history.replaceState({ ff: values }, '', collectionUrl + (qs ? '?' + qs : ''));
    }

    function navigateBase(values) {
      var params = new URLSearchParams();
      if (values.length) params.set('ff', values.join(','));
      var qs = params.toString();
      window.location.href = collectionUrl + (qs ? '?' + qs : '');
    }

    // Group selected values by their group key. Returns { groupKey: [values...] }
    function groupSelected(values) {
      var groups = {};
      values.forEach(function (v) {
        var g = (valueMeta[v] && valueMeta[v].group) || 'group';
        (groups[g] = groups[g] || []).push(v);
      });
      return groups;
    }

    function apply(values) {
      values = values || getSelected();
      var groups = groupSelected(values);
      var groupKeys = Object.keys(groups);
      var shown = 0;

      items.forEach(function (it) {
        var match = true;
        // AND across groups: item must satisfy every active group
        for (var gi = 0; gi < groupKeys.length; gi++) {
          var groupVals = groups[groupKeys[gi]];
          // OR within group: item must match at least one value in this group
          var groupHit = false;
          for (var vi = 0; vi < groupVals.length; vi++) {
            if (it.__tags.indexOf(groupVals[vi]) >= 0) { groupHit = true; break; }
          }
          if (!groupHit) { match = false; break; }
        }
        it.style.display = match ? '' : 'none';
        if (match) shown++;
      });

      if (resultCount) {
        if (values.length) { resultCount.textContent = shown + ' result' + (shown === 1 ? '' : 's'); resultCount.hidden = false; }
        else { resultCount.hidden = true; }
      }
      if (emptyEl) emptyEl.hidden = !(values.length && shown === 0);

      root.querySelectorAll('[data-ff-value]').forEach(function (el) {
        var v = el.getAttribute('data-ff-value');
        var active = values.indexOf(v) >= 0;
        if (el.classList.contains('jaco-ff__pill')) {
          el.classList.toggle('is-active', active);
          el.setAttribute('aria-pressed', active ? 'true' : 'false');
        }
        if (el.matches && el.matches('input[type="checkbox"]')) el.checked = active;
      });
      root.querySelectorAll('[data-ff-clear]').forEach(function (b) { b.hidden = values.length === 0; });
      if (badge) { badge.textContent = values.length; badge.hidden = values.length === 0; }
      renderChips(values);
    }

    function renderChips(values) {
      if (!activeWrap) return;
      if (!values.length) { activeWrap.innerHTML = ''; activeWrap.hidden = true; return; }
      activeWrap.hidden = false;
      activeWrap.innerHTML = values.map(function (v) {
        var label = (valueMeta[v] && valueMeta[v].label) || v;
        return '<button type="button" class="jaco-ff__chip" data-ff-value="' + v + '">' +
               label + ' <span aria-hidden="true">&times;</span></button>';
      }).join('');
    }

    function toggle(value) {
      var sel = getSelected();
      var i = sel.indexOf(value);
      if (i >= 0) sel.splice(i, 1);
      else sel.push(value);
      if (onTagSubPath()) { navigateBase(sel); return; }
      writeUrl(sel);
      apply(sel);
    }

    function clearAll() {
      if (onTagSubPath()) { navigateBase([]); return; }
      writeUrl([]); apply([]);
    }

    // Drawer
    var overlay = root.querySelector('[data-ff-overlay]');
    var drawer = root.querySelector('[data-ff-drawer]');
    function openDrawer() {
      if (overlay) overlay.hidden = false;
      if (drawer) drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      var t = root.querySelector('[data-ff-open]'); if (t) t.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      if (overlay) overlay.hidden = true;
      if (drawer) drawer.hidden = true;
      document.body.style.overflow = '';
      var t = root.querySelector('[data-ff-open]'); if (t) t.setAttribute('aria-expanded', 'false');
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ff-open]')) { openDrawer(); return; }
      if (e.target.closest('[data-ff-close]')) { closeDrawer(); return; }
      if (e.target.closest('[data-ff-clear]')) { clearAll(); return; }
      var pill = e.target.closest('.jaco-ff__pill');
      if (pill) { toggle(pill.getAttribute('data-ff-value')); return; }
      var chip = e.target.closest('.jaco-ff__chip');
      if (chip) { toggle(chip.getAttribute('data-ff-value')); return; }
    });
    if (overlay) overlay.addEventListener('click', closeDrawer);
    root.addEventListener('change', function (e) {
      var cb = e.target.closest('input[type="checkbox"][data-ff-value]');
      if (cb) toggle(cb.getAttribute('data-ff-value'));
    });
    if (emptyEl) emptyEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-ff-clear]')) clearAll();
    });

    apply(getSelected());
  }

  function boot() { document.querySelectorAll('[data-jaco-ff]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
